import {
  DELETE_SERVER_SIDE_ASYNC,
  DISABLE_MAILBOX_ASYNC,
  MAILBOX_REQUEST_ASYNC,
  SERVER_SIDE_REQUEST_ASYNC,
  UPDATE_MAILBOX_ASYNC,
  UPDATE_SERVER_SIDE_ASYNC,
} from './constants'

const getExchangeInfo = (payload = {}) => ({ type: SERVER_SIDE_REQUEST_ASYNC.INITIATE, payload })
export const getExchangeInfoSuccess = (data) => ({
  type: SERVER_SIDE_REQUEST_ASYNC.SUCCESS,
  payload: { data },
})
export const getExchangeInfoError = (error) => ({
  type: SERVER_SIDE_REQUEST_ASYNC.ERROR,
  error,
})
const getExchangeInfoCancel = () => ({ type: SERVER_SIDE_REQUEST_ASYNC.CANCEL })

const updExchangeInfo = (payload = {}) => ({ type: UPDATE_SERVER_SIDE_ASYNC.INITIATE, payload })
export const updExchangeInfoSuccess = (data) => ({
  type: UPDATE_SERVER_SIDE_ASYNC.SUCCESS,
  payload: { data },
})
export const updExchangeInfoError = (error) => ({
  type: UPDATE_SERVER_SIDE_ASYNC.ERROR,
  error,
})
const updExchangeInfoCancel = () => ({ type: UPDATE_SERVER_SIDE_ASYNC.CANCEL })

const delExchangeInfo = () => ({ type: DELETE_SERVER_SIDE_ASYNC.INITIATE })
export const delExchangeInfoSuccess = (data) => ({
  type: DELETE_SERVER_SIDE_ASYNC.SUCCESS,
  payload: { data },
})
export const delExchangeInfoError = (error) => ({
  type: DELETE_SERVER_SIDE_ASYNC.ERROR,
  error,
})

const getMailboxInfo = () => ({ type: MAILBOX_REQUEST_ASYNC.INITIATE })
export const getMailboxInfoSuccess = (data) => ({
  type: MAILBOX_REQUEST_ASYNC.SUCCESS,
  payload: { data },
})
export const getMailboxInfoError = (error) => ({
  type: MAILBOX_REQUEST_ASYNC.ERROR,
  error,
})
const getMailboxInfoCancel = () => ({ type: MAILBOX_REQUEST_ASYNC.CANCEL })

const updMailbox = (value) => ({
  type: UPDATE_MAILBOX_ASYNC.INITIATE,
  payload: { value },
})
export const updMailboxSuccess = (data) => ({
  type: UPDATE_MAILBOX_ASYNC.SUCCESS,
  payload: { data },
})
export const updMailboxError = (error) => ({
  type: UPDATE_MAILBOX_ASYNC.ERROR,
  error,
})

export const disableMailbox = () => ({ type: DISABLE_MAILBOX_ASYNC.INITIATE })
export const disableMailboxSuccess = () => ({
  type: DISABLE_MAILBOX_ASYNC.SUCCESS,
})
export const disableMailboxError = (error) => ({
  type: DISABLE_MAILBOX_ASYNC.ERROR,
  error,
})

export default {
  // to props
  getExchangeInfo,
  getExchangeInfoCancel,
  updExchangeInfo,
  updExchangeInfoCancel,
  getMailboxInfo,
  getMailboxInfoCancel,
  delExchangeInfo,
  updMailbox,
  disableMailbox,
}
